<template>
  <li class="nav-item">
    <router-link
      v-tooltip.right="
        collapsed && !isMobileTablet ? 'Booking Requests' : false
      "
      :to="{ name: 'booking-requests' }"
      class="nav-link u-mr-8 text-nowrap d-flex align-items-center"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      @click="$emit('navigated')"
    >
      <i class="fa fa-inbox app-sidebar__icon" aria-hidden="true" />
      <span class="app-sidebar__label">Booking Requests</span>
      <span
        v-show="showBadge"
        class="badge badge-pill badge-theme ml-1 app-sidebar__badge"
      >
        {{ pendingBookingRequestsCount }}
      </span>
    </router-link>
  </li>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["navigated"],
  mounted() {
    const vm = this;
    this.getPendingBookingRequestsCount();
    window.Echo.encryptedPrivate("booking-requests").listen(
      "BookingRequestStatusUpdated",
      (e) => {
        if (e.environment_name != this.companyName) return;
        if (vm.loggedInUser) {
          if (vm.loggedInUser.isAdmin || vm.loggedInUser.isManagingAdmin) {
            if (e?.status === "pending") {
              vm.updatePendingBookingRequestsCount(1);
            } else {
              vm.updatePendingBookingRequestsCount(-1);
            }
          } else if (
            vm.loggedInUser.isProvider &&
            e?.providers &&
            e?.providers?.includes(vm.loggedInUser.id)
          ) {
            if (e?.status === "pending") {
              vm.updatePendingBookingRequestsCount(1);
            } else {
              vm.updatePendingBookingRequestsCount(-1);
            }
          } else if (e.user_id == vm.loggedInUser.id) {
            if (e?.status === "pending") {
              vm.updatePendingBookingRequestsCount(1);
            } else {
              vm.updatePendingBookingRequestsCount(-1);
            }
          }
        }
      }
    );
  },
  computed: {
    ...mapState({
      loggedInUser: (state) => state.auth.user,
      pendingBookingRequestsCount: (state) =>
        state.booking.pendingBookingRequestsCount,
      companyName: (state) => (state.settings.companyProfile || {}).name || "",
      deviceType: (state) => state.settings.deviceType,
    }),
    showBadge: function () {
      return this.pendingBookingRequestsCount;
    },
    isMobileTablet: function () {
      return this.deviceType == "mobile" || this.deviceType == "tablet";
    },
  },
  methods: {
    ...mapActions({
      getPendingBookingRequestsCount: "booking/getPendingBookingRequestsCount",
      updatePendingBookingRequestsCount:
        "booking/updatePendingBookingRequestsCount",
    }),
  },
};
</script>
<style lang="scss" scoped>
.badge-theme {
  background-color: var(--theme-color);
  color: var(--btn-text-color);
  font-size: 12px;
}
</style>
